import MainNavbar from '../../layout/MainNavbar.vue';
import MainFooter from '../../layout/MainFooter.vue';


export default [
    {
        path: '/login',
        name: 'login',
        components: { default: resolve => require (['./login/Login.vue'],resolve)},
        meta:{
          title:"海外 - 登录"
        }
    },
    {
        path: '/resetpassword',
        name: 'resetpassword',
        components: { default: resolve => require (['./login/ResetPassword.vue'],resolve)},
        meta:{
          title:"海外 - 忘记密码"
        }
    },
    {
        path: '/blog_register',
        name: 'blog_register',
        components: { default: resolve => require (['./login/RegistBlog.vue'],resolve), header: MainNavbar},
        meta:{
          title:"海外 - 注册"
        }
    },
    {
        path: '/profile',
        name: 'profile',
        components: { default: resolve => require (['./homepage/Profile.vue'],resolve), header: MainNavbar},
        meta:{requiresAuth:true,title:"海外 - 个人设置"}
    },
    {
        path: '/bookmark',
        name: 'bookmark',
        components: { default: resolve => require (['./homepage/BookMark.vue'],resolve), header: MainNavbar},
        meta:{requiresAuth:true,title:"海外"}
    },
    {
        path:'/notices',
        name:'notices',
        components:{default: resolve => require (['./notices/Notices.vue'],resolve), header: MainNavbar},
        meta:{requiresAuth:true,title:"海外 - 消息"}
    },
    {
        path: '/userindex/:id',
        name: 'userindex',
        components: { default: resolve => require (['./homepage/UserIndex.vue'],resolve), header: MainNavbar},
        meta:{requiresAuth:false,title:"海外 - 个人主页"}
    }
]
